var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "26.4 20 147 159.989",
    viewBox: "0 0 200 200",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 127.9c0 5.7-4.6 10.4-10.3 10.4s-10.3-4.6-10.3-10.4c0-5.7 4.6-10.4 10.3-10.4s10.3 4.7 10.3 10.4z",
    fill: "#fbc8c3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 127.9c0 5.7-4.6 10.4-10.3 10.4s-10.3-4.6-10.3-10.4c0-5.7 4.6-10.4 10.3-10.4S94 122.2 94 127.9z",
    fill: "#fbc8c3",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 107c.2-6 .7-11.9 1.4-17.9 3-22.7 21.5-37.7 41.7-38h1.8c20.2.3 38.7 15.3 41.7 38 .8 5.9 1.3 11.9 1.4 17.9.1 3.7 1.5 5.7 4.9 7.4.5.3 1 .6 1.6.9 13.8-8.3 22.4-19.8 22.4-32.6 0-19.2-19.4-35.7-46.7-42.3 0 0-.1 0-.1-.1-8.3-2-17.3-3.1-26.7-3.1-40.6 0-73.5 20.3-73.5 45.4 0 13 8.8 24.7 23 33l2.1-1.2c3.5-1.7 4.9-3.6 5-7.4z",
    fill: "#fb0000",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8 144.2l-3.6-3.6c-.8-.8-1.7-1.4-2.8-1.9-1-.4-2-.2-2.8.6-.2.2-.6.2-.8 0-.7-.7-1.8-1-2.8-.6-1 .4-2 1.1-2.8 1.9l-3.6 3.6 3.6 3.6c1.6 1.6 3.8 2.5 6 2.5s4.3-.8 6-2.5l3.6-3.6zm-7.5.6c-.6.3-1.3.4-2.1.4s-1.5-.2-2.1-.4c-.6-.2-1-.6-1-.6s.4-.3 1-.6 1.3-.4 2.1-.4 1.5.2 2.1.4c.6.2 1 .6 1 .6s-.4.3-1 .6z",
    fill: "#fb0000",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7 110.4a32.53 32.53 0 0 1-8.8 0c-1.5-.2-3.1-.6-5.2-1l-.2.2c1.2 1.3 2.8 2.4 4.4 3.1 1.7.7 3.5 1.1 5.3 1.1 1.8 0 3.6-.4 5.3-1.1 1.7-.7 3.2-1.8 4.4-3.1l-.2-.2c-1.9.5-3.5.9-5 1z",
    fill: "#041354",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7 40.4s.1 0 .1.1C125.9 29 114 20 99.5 20 84.9 20 73 29.1 72.2 40.5c7.1-3.7 16.7-6 27.3-6 10.5 0 20.1 2.3 27.2 5.9z",
    fill: "#041354",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 115.4c-.5-.3-1-.6-1.6-.9-3.4-1.8-4.7-3.7-4.9-7.4-.2-6-.7-11.9-1.4-17.9-3-22.7-21.5-37.7-41.7-38h-1.8c-20.2.3-38.7 15.3-41.7 38-.8 5.9-1.3 11.9-1.4 17.9-.1 3.7-1.5 5.7-4.9 7.4l-2.1 1.2c-21.9 13.3-22.5 45-.3 59.1 16.2 10.3 38.9 4.7 47.3-11.8-.4-.2-.7-.4-1.1-.6-8.1-2.3-15-9.4-19.5-19.7-.2-.4-.5-.8-.7-1.2l.2-.1c2.1-1.6 4.2-3 6.1-4.6 3.2-2.8 5.8-5.8 7.7-9.1 2.8-4.7 4.3-9.9 4.5-15.8 1-.6 1.9-1.3 2.7-2.2l-.2-.2c-.9.2-1.7.4-2.4.5v-.6c-.2-5.9.6-4.3.7-10.2.1-4.8-.4-9.3.1-12.3 0-.2.1-.4.1-.6 0-.1.1-.2.1-.4s.1-.3.2-.4c0-.1.1-.2.1-.4.1-.1.1-.2.2-.4s.3-.4.5-.6l.3-.3c.1-.1.2-.2.3-.2.1-.1.3-.2.4-.2.1-.1.2-.1.3-.1.2-.1.4-.1.5-.2.1 0 .2-.1.3-.1.3-.1.7-.1 1-.1l.8.8c2.4 2.2 4.6 3 6.7 3.1h1.3c.2 0 .3 0 .5-.1h.2c2.9-.5 5.6-2.1 8.3-2.6.2 0 .5-.1.7-.1h.1c.5-.1 1-.1 1.5 0h.1c.2 0 .4 0 .6.1h.2c.2 0 .5.1.7.2.2.1.5.2.7.3.1 0 .1.1.2.1l.6.3c.1 0 .1.1.2.1.2.1.5.3.7.5.3.2.5.4.8.6l.2.2.6.6.2.2c.3.3.5.6.8.9 3.3 7.9 5.3 17.5 5.3 27.8 0 2.7-.1 5.4-.4 8-2.2 20.9-12.6 36.2-25.8 38.8-.1.1-.2.1-.3.2 8.5 16.6 31.1 22.2 47.3 11.8 22.5-14.2 21.8-46.2-.7-59.3z",
    fill: "#041354",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7 142.4c0 1.9-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5 1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5z",
    fill: "#fb0000",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8 139.5c-1.9.3-3.2 2.1-3 4 .3 1.9 2.1 3.3 4 3 1.9-.3 3.2-2.1 2.9-4-.2-2-2-3.3-3.9-3z",
    fill: "#fb0000",
    "data-color": 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeace);
export default __webpack_public_path__ + "static/media/peace.29604d10be8e79b9e6b6901b92d33336.svg";
export { ForwardRef as ReactComponent };